import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from './auth.service';
import { NotificationService } from '../../../../core/services/notification.service';
import { SessionService } from '../../user-management/services/session.service';

@Injectable({
  providedIn: 'root'
})
export class LogoutService {
  constructor(
    private readonly authService: AuthService,
    private readonly sessionService: SessionService,
    private readonly notificationService: NotificationService,
    private readonly router: Router
  ) { }

  logout(showMessage = true): void {
    this.sessionService.clearTimer();  // Detiene cualquier contador activo
    this.authService.removeToken();   // Borra el token y datos relacionados
    if (showMessage) {
      this.notificationService.showSuccess('Sesión cerrada correctamente');
    }
    this.router.navigate(['/login']);
  }
}
